import { createLucideIcon } from 'lucide-react';
export const DashboardIcon = createLucideIcon('dashboard-icon', [
  [
    'path',
    {
      d: 'M11.9997 6.89999C12.1816 6.89999 12.3337 7.05027 12.3337 7.23495C12.3337 7.41966 12.1816 7.56992 11.9997 7.56992C11.8179 7.56974 11.6667 7.41955 11.6667 7.23495C11.6667 7.05038 11.818 6.90017 11.9997 6.89999Z',
      key: '1bxo2u',
    },
  ],
  [
    'path',
    {
      d: 'M12 4.5C17.259 4.5 21.5 8.74099 21.5 14C21.5 16.0579 20.8086 17.9393 19.6836 19.5H4.31641C3.19144 17.9393 2.5 16.0579 2.5 14C2.5 8.74099 6.74099 4.5 12 4.5Z',
      key: '19gq3w',
    },
  ],
  [
    'path',
    {
      d: 'M15.333 7.75C15.5149 7.75 15.667 7.90028 15.667 8.08496C15.667 8.26966 15.5149 8.41992 15.333 8.41992C15.1513 8.41974 15 8.26955 15 8.08496C15 7.90039 15.1513 7.75018 15.333 7.75Z',
      key: '1d4msr',
    },
  ],
  [
    'path',
    {
      d: 'M17.6849 10.834L13.4271 13.1611L13.1663 13.3037V13.6172C13.1577 14.1969 12.6577 14.7 12.0003 14.7002C11.3358 14.7002 10.8333 14.1888 10.8333 13.5996C10.8335 13.0106 11.3359 12.5 12.0003 12.5C12.2065 12.5001 12.4093 12.5604 12.5882 12.6611L12.8304 12.7979L13.0745 12.6631L17.3646 10.2959L17.6849 10.834Z',
      key: '13tk73',
    },
  ],
  [
    'path',
    {
      d: 'M17.7809 16.5C17.9628 16.5 18.1149 16.6503 18.1149 16.835C18.1149 17.0197 17.9628 17.1699 17.7809 17.1699C17.5992 17.1697 17.4479 17.0196 17.4479 16.835C17.448 16.6504 17.5992 16.5002 17.7809 16.5Z',
      key: 'keyij0',
    },
  ],
  [
    'path',
    {
      d: 'M18.6664 13.3C18.8483 13.3 19.0003 13.4503 19.0004 13.6349C19.0004 13.8197 18.8483 13.9699 18.6664 13.9699C18.4846 13.9697 18.3334 13.8195 18.3334 13.6349C18.3334 13.4504 18.4846 13.3002 18.6664 13.3Z',
      key: '100xb6',
    },
  ],
  [
    'path',
    {
      d: 'M5.33301 13.3C5.5149 13.3 5.66697 13.4503 5.66699 13.6349C5.66699 13.8197 5.51491 13.9699 5.33301 13.9699C5.15125 13.9697 5 13.8195 5 13.6349C5.00002 13.4504 5.15126 13.3002 5.33301 13.3Z',
      key: '1bp82p',
    },
  ],
  [
    'path',
    {
      d: 'M6.21844 10.1C6.40033 10.1 6.55241 10.2503 6.55243 10.435C6.55243 10.6197 6.40034 10.7699 6.21844 10.7699C6.03669 10.7697 5.88544 10.6196 5.88544 10.435C5.88546 10.2504 6.0367 10.1002 6.21844 10.1Z',
      key: '1ky39r',
    },
  ],
  [
    'path',
    {
      d: 'M6.21844 16.5C6.40033 16.5 6.55241 16.6503 6.55243 16.835C6.55243 17.0197 6.40034 17.1699 6.21844 17.1699C6.03669 17.1697 5.88544 17.0196 5.88544 16.835C5.88546 16.6504 6.0367 16.5002 6.21844 16.5Z',
      key: 'svzryf',
    },
  ],
  [
    'path',
    {
      d: 'M8.66638 7.75C8.84827 7.75 9.00035 7.90028 9.00037 8.08496C9.00037 8.26966 8.84828 8.41992 8.66638 8.41992C8.48463 8.41974 8.33337 8.26955 8.33337 8.08496C8.3334 7.90039 8.48464 7.75018 8.66638 7.75Z',
      key: 'exyary',
    },
  ],
]);
